import { Radio } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useState } from "react";
import checkMarkChecked from "../svg/check-mark-checked.svg";
import checkMarkHelpChecked from "../svg/check-mark-help-checked.svg";
import checkMarkHelpUnchecked from "../svg/check-mark-help-unchecked.svg";
import checkMarkUnchecked from "../svg/check-mark-unchecked.svg";

const List = ({
  errors,
  touched,
  label,
  icon,
  onChange,
  values,
  value,
  required,
  subLabel,
  style,
  orientation,
  ...rest
}) => {
  const [checkedValue, setCheckedValue] = useState(value);
  const onSelect = ({ target: { value } }) => {
    setCheckedValue(value);
    onChange(value);
  };

  return (
    <div
      className={classNames("lmfRadio__list", {
        "lmfRadio__list--row": orientation === "row",
      })}
    >
      <Radio.Group
        onChange={onSelect}
        value={checkedValue}
        defaultValue={value}
        optionType="button"
        {...rest}
      >
        {values.map(
          ({ label, value: _value, subLabel, onHelpClick }) =>
            !(_value === checkedValue && _value === "CUSTOM") && (
              <Radio
                value={_value}
                className={classNames(
                  "lmfRadio__list--item",
                  { checked: checkedValue },
                  { text: !subLabel },
                )}
                key={`radio-${_value}`}
              >
                <div className="lmfRadio__list--wrapper">
                  {subLabel && (
                    <div className="lmfRadio__list--check-mark">
                      <img
                        src={
                          _value === checkedValue
                            ? checkMarkChecked
                            : checkMarkUnchecked
                        }
                        alt=""
                      />
                    </div>
                  )}
                  <div className="lmfRadio__list--content">
                    <p className="lmfRadio__list--title">{label}</p>
                    <p className="lmfRadio__list--desc">{subLabel}</p>
                  </div>
                  {subLabel && (
                    <div
                      className="lmfRadio__list--help"
                      onClick={() => onHelpClick(_value)}
                    >
                      <img
                        src={
                          _value === checkedValue
                            ? checkMarkHelpChecked
                            : checkMarkHelpUnchecked
                        }
                        alt=""
                      />
                    </div>
                  )}
                </div>
              </Radio>
            ),
        )}
      </Radio.Group>
      {touched && errors && <p className={"input--errors"}>{errors}</p>}
    </div>
  );
};

List.propTypes = {
  loading: PropTypes.bool,
  hidePlaceholder: PropTypes.bool,
  placeholder: PropTypes.node,
  onChange: PropTypes.func,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.any,
    }),
  ),
  value: PropTypes.any,
  orientation: PropTypes.oneOf(["column", "row"]),
};

List.defaultProps = {
  onChange: () => {},
  values: [],
  orientation: "column",
};
export default List;
